<template>
    <div class="card">
        <div class="card-body">
            <div class="user-activity">
                <h5>ACTIVITY</h5>
                <ul class="reset">
                    <li v-for="(activity, i) in activitydetail" v-bind:key="'activity_' + i">{{ readableText(activity) }}</li>
                </ul>

                <p v-if="activitydetail.length === 0" class="mb-0">No tracking activity found.</p>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    props: ['activitydetail'],
    methods: {
        readableText(activity) {
            let str = activity.user_full_name;
            str += ' - ' + activity.action_type.replace(/_/g, ' ');
            str += ' - ' + moment(activity.created_at).format('YYYY/MM/DD HH:mm');

            return str;
        }
    }
};
</script>
